import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as actions from './actions';

export const initialState = {
  config: {},
  files: [],
  counts: {},
  isLoading: false,
  isUploading: false,
  uploadProgress: 0,
  uploadFileIndex: 0,
  uploadFileCount: 0,
  isUpdating: false,
  error: {},
  success: {},
};

const setFetchConfigRequest = (state) =>
  update(state, {
    error: { $set: {} },
  });

const setFetchConfigSuccess = (state, action) =>
  update(state, {
    config: { $set: action.payload },
  });

const setFetchConfigFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
  });

const setFetchFilesRequest = (state) =>
  update(state, {
    isLoading: { $set: true },
    error: { $set: {} },
  });

const setFetchFilesSuccess = (state, action) =>
  update(state, {
    isLoading: { $set: false },
    files: { $set: action.payload },
  });

const setFetchFilesFailure = (state, action) =>
  update(state, {
    isLoading: { $set: false },
    error: { $set: action.payload.error },
  });

const setFetchCountsRequest = (state) => state;

const setFetchCountsSuccess = (state, action) =>
  update(state, {
    counts: { $set: action.payload },
  });

const setFetchCountsFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
  });

const setUploadRequest = (state) =>
  update(state, {
    isUploading: { $set: true },
    uploadProgress: { $set: 0 },
    uploadFileIndex: { $set: 0 },
    uploadFileCount: { $set: 0 },
    error: { $set: {} },
    success: { $set: {} },
  });

const setUploadProgress = (state, action) =>
  update(state, {
    uploadProgress: { $set: action.payload },
  });

const setBatchProgress = (state, action) => {
  const { fileIndex, fileCount, fileProgress } = action.payload;
  if (!fileCount) return state;
  const overall = Math.round((fileIndex * 100 + fileProgress) / fileCount);
  return update(state, {
    uploadProgress: { $set: overall },
    uploadFileIndex: { $set: fileIndex },
    uploadFileCount: { $set: fileCount },
  });
};

const setUploadSuccess = (state, action) =>
  update(state, {
    isUploading: { $set: false },
    uploadProgress: { $set: 100 },
    success: { $set: action.payload.success || { message: 'File uploaded' } },
  });

const setUploadFailure = (state, action) =>
  update(state, {
    isUploading: { $set: false },
    uploadProgress: { $set: 0 },
    error: { $set: action.payload.error },
  });

const setRenameRequest = (state) =>
  update(state, {
    isUpdating: { $set: true },
    error: { $set: {} },
    success: { $set: {} },
  });

const setRenameSuccess = (state, action) =>
  update(state, {
    isUpdating: { $set: false },
    success: { $set: action.payload.success || { message: 'File renamed' } },
  });

const setRenameFailure = (state, action) =>
  update(state, {
    isUpdating: { $set: false },
    error: { $set: action.payload.error },
  });

const setReassignRequest = (state) =>
  update(state, {
    isUpdating: { $set: true },
    error: { $set: {} },
    success: { $set: {} },
  });

const setReassignSuccess = (state, action) =>
  update(state, {
    isUpdating: { $set: false },
    success: { $set: action.payload.success || { message: 'File reassigned' } },
  });

const setReassignFailure = (state, action) =>
  update(state, {
    isUpdating: { $set: false },
    error: { $set: action.payload.error },
  });

const setDeleteRequest = (state) =>
  update(state, {
    isUpdating: { $set: true },
    error: { $set: {} },
    success: { $set: {} },
  });

const setDeleteSuccess = (state, action) =>
  update(state, {
    isUpdating: { $set: false },
    success: { $set: action.payload.success || { message: 'File deleted' } },
  });

const setDeleteFailure = (state, action) =>
  update(state, {
    isUpdating: { $set: false },
    error: { $set: action.payload.error },
  });

const setClearStatus = (state) =>
  update(state, {
    success: { $set: {} },
    error: { $set: {} },
  });

const setErrorFromAction = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
  });

export default handleActions(
  {
    [actions.FETCH_HOST_FILES_CONFIG_REQUEST]: setFetchConfigRequest,
    [actions.FETCH_HOST_FILES_CONFIG_SUCCESS]: setFetchConfigSuccess,
    [actions.FETCH_HOST_FILES_CONFIG_FAILURE]: setFetchConfigFailure,

    [actions.FETCH_HOST_FILES_REQUEST]: setFetchFilesRequest,
    [actions.FETCH_HOST_FILES_SUCCESS]: setFetchFilesSuccess,
    [actions.FETCH_HOST_FILES_FAILURE]: setFetchFilesFailure,

    [actions.FETCH_HOST_FILES_COUNTS_REQUEST]: setFetchCountsRequest,
    [actions.FETCH_HOST_FILES_COUNTS_SUCCESS]: setFetchCountsSuccess,
    [actions.FETCH_HOST_FILES_COUNTS_FAILURE]: setFetchCountsFailure,

    [actions.UPLOAD_HOST_FILE_REQUEST]: setUploadRequest,
    [actions.UPLOAD_HOST_FILE_PROGRESS]: setUploadProgress,
    [actions.UPLOAD_HOST_FILE_BATCH_PROGRESS]: setBatchProgress,
    [actions.UPLOAD_HOST_FILE_SUCCESS]: setUploadSuccess,
    [actions.UPLOAD_HOST_FILE_FAILURE]: setUploadFailure,

    [actions.RENAME_HOST_FILE_REQUEST]: setRenameRequest,
    [actions.RENAME_HOST_FILE_SUCCESS]: setRenameSuccess,
    [actions.RENAME_HOST_FILE_FAILURE]: setRenameFailure,

    [actions.REASSIGN_HOST_FILE_REQUEST]: setReassignRequest,
    [actions.REASSIGN_HOST_FILE_SUCCESS]: setReassignSuccess,
    [actions.REASSIGN_HOST_FILE_FAILURE]: setReassignFailure,

    [actions.DELETE_HOST_FILE_REQUEST]: setDeleteRequest,
    [actions.DELETE_HOST_FILE_SUCCESS]: setDeleteSuccess,
    [actions.DELETE_HOST_FILE_FAILURE]: setDeleteFailure,

    [actions.VIEW_HOST_FILE_FAILURE]: setErrorFromAction,
    [actions.DOWNLOAD_HOST_FILE_FAILURE]: setErrorFromAction,

    [actions.CLEAR_HOST_FILES_STATUS]: setClearStatus,
  },
  initialState,
);
